import { EInvoiceDiscountDto } from "../e-invoice-discount";
import { EInvoiceExemptTvaZone, EInvoiceTvaType } from "../e-invoice-tva";
import { EInvoiceItemType } from "./e-invoice-item-type.enum";

export class EInvoiceItemDto {
  Id: number;
  Title: string;
  Description: string | null;
  Quantity: number | null;
  UnitPrice: number | null;
  VatPercent: number | null;
  TotalHt: number | null;
  TotalTtc: number | null;
  TotalTva: number | null;
  LineTotalAmount: number | null;
  TvaType: EInvoiceTvaType;
  Type: EInvoiceItemType;
  Discount: EInvoiceDiscountDto | null;
  ExemptTvaZone: EInvoiceExemptTvaZone | null;
}

export class EditInvoiceItemRequest {
  Id: number;
  Title: string | null;
  Description: string | null;
  Quantity: number | null;
  UnitPrice: number | null;
  VatPercent: number | null;
  TvaType: EInvoiceTvaType;
  Type: EInvoiceItemType;
  DiscountPercent: number | null;
  ExemptTvaZone: EInvoiceExemptTvaZone | null;
}

export class AddInvoiceItemRequest {
  Title: string | null;
  Description: string | null;
  Quantity: number | null;
  UnitPrice: number | null;
  VatPercent: number | null;
  TvaType: EInvoiceTvaType;
  Type: EInvoiceItemType;
  DiscountPercent: number | null;
  ExemptTvaZone: EInvoiceExemptTvaZone | null;
}

export * from "./e-invoice-item-type.enum";
